module.exports = __webpack_public_path__ + "img/Recurso 21@300xe.61ba2b3b.webp";